export default __webpack_public_path__ + "static/media/project-2.d0c4c964.png";